import React, { useContext } from "react";
import cam from "../im/vecal.png"
import user from "../im/user.png"
import more from "../im/more.png"
import Messages from "./Messages";
import Input from "./Input";
import { ChatContext } from "../context/ChatContext";


const Chat=()=>{
    const { data }=useContext(ChatContext);
    console.log(data);
    return(
        <div className="Chat">
            <div className="ChatInfo">
                <span>{data.user?.displayName}</span>
                <div className="ChatIcons">
                    <img src={cam} alt="" />
                    <img src={user} alt="" />
                    <img src={more} alt="" />
                </div>
                
            </div>
            <Messages/>
            <Input/>
        </div>
    )
}

export default Chat